// @flow

import React from 'react'
import styled, { css } from 'styled-components'
import { formatDateFriendly, getEndDate } from 'src/helpers/dates'
import { media } from 'src/theme/style-utils'
import { roundToTwo } from 'src/helpers/normalize'

import type {
  Theme as ThemeType,
  Membership as MembershipType,
  Booking as BookingType,
  MoveIn as MoveInType
} from 'src/types'

type Props = {
  membership: MembershipType,
  booking: BookingType,
  moveIn: MoveInType,
  noMargin?: boolean,
  modalLayout?: boolean
}

export const StyledBookingSummary = styled.div`
  ${media.phone`
  ${props =>
    props.modalLayout
      ? css`
          margin: 0 0 10px 0;
        `
      : css`
          margin: 0 20px 10px 20px;

          ${media.tabletLarge`
          margin: 0 40px 10px 40px;
        `}
        `}
   
  `}

  ${(props: Props) =>
    props.noMargin &&
    css`
      margin: 0 0 30px 0;
    `};
`

export const Heading = styled.header`
  font-family: 'RelativeMedium';
  font-size: 16px;
  font-weight: 500;
  color: ${(props: { theme: ThemeType }) => props.theme.darkText};
  padding: 8px 2px 5px 2px;
`

export const SummaryTable = styled.table`
  width: 100%;
`

export const SummaryRow = styled.tr`
  td {
    padding: 5px 0;
  }
`

export const Label = styled.td`
  font-size: 14px;
  color: ${(props: { theme: ThemeType }) => props.theme.lightText};
`

export const Value = styled.td`
  font-size: 14px;
  font-family: 'RelativeBook';
  color: ${(props: { theme: ThemeType }) => props.theme.black};
  text-align: right;
`

const HorizRule = styled.hr`
  border-top: ${(props: { theme: ThemeType }) => `1px solid ${props.theme.secondary}`};
`

export const BookingSummary = ({
  booking,
  membership,
  moveIn,
  noMargin,
  modalLayout = false
}: Props) => {
  const { value, weeklyPrice } = membership
  const { location, preferredFloor } = booking

  const floors = {
    tcoo: { lower: '2-7', higher: '8-10', '2_to_7': '2-7', '8_to_10': '8-10' },
    tccw: { lower: '3', mid: '4-8', higher: '17-19 ' }
  }

  const moveOut = formatDateFriendly(getEndDate(moveIn.value, value))
  const floorNumber = floors[location.ref] && floors[location.ref][preferredFloor]

  return (
    <StyledBookingSummary noMargin={noMargin} modalLayout={modalLayout}>
      {/* <Heading>Application Summary</Heading> */}
      <SummaryTable>
        <tbody>
          <SummaryRow>
            <Label>Location</Label>
            <Value>{location.displayName}</Value>
          </SummaryRow>
          <SummaryRow>
            <Label>Floor</Label>
            {/* <Value>{floorNumber.substring(0, floorNumber.indexOf('('))}</Value> */}
            <Value>{floorNumber}</Value>
          </SummaryRow>
          <SummaryRow>
            <Label>Licence Fee</Label>
            <Value>{`£${roundToTwo((weeklyPrice * 52) / 12)} pm (£${weeklyPrice} pw)`}</Value>
          </SummaryRow>
        </tbody>
      </SummaryTable>
      <HorizRule />
      <Heading>Dates</Heading>
      <SummaryTable>
        <tbody>
          {/* <SummaryRow>
            <Label>Membership Period</Label>
            <Value>{`${value} months`}</Value>
          </SummaryRow> */}
          <SummaryRow>
            <Label>Move-in</Label>
            <Value>{`${formatDateFriendly(moveIn.value.toString())}`}</Value>
          </SummaryRow>
          <SummaryRow>
            <Label>Renewal / end date</Label>
            <Value>{`${moveOut}`}</Value>
          </SummaryRow>
        </tbody>
      </SummaryTable>
    </StyledBookingSummary>
  )
}



// WEBPACK FOOTER //
// ./src/components/BookingSummary/index.js